import {appendChildForGolosNarodaWidget} from './dom-manipulation';
import {renderGolosNarodaWidget} from './render-golos-naroda-widget';

const renderGolosNarodaWidgetInInfinite = container => {
  if (!container) {
    return;
  }
  appendChildForGolosNarodaWidget(container);
  const element = document.getElementById('golos-naroda-widget');

  renderGolosNarodaWidget({containerElement: element});
};

export {renderGolosNarodaWidgetInInfinite};
